// The table uses server pagination, so its default header checkbox only sees one page.
export default function createTraineeTableSelection({canSelectMethod, request}) {
    return {
        data() {
            return {selectionLoading: false, allSelectionIds: []};
        },
        computed: {
            traineeSelectionQuery() {
                return this.getTraineeListParams({page: 1, itemsPerPage: -1});
            },
            allTraineesSelected() {
                const selectedIds = new Set(this.selected.map((item) => String(item.id)));
                return this.allSelectionIds.length > 0 &&
                    this.allSelectionIds.every((id) => selectedIds.has(id));
            },
        },
        watch: {
            traineeSelectionQuery() {
                this.selected = [];
                this.allSelectionIds = [];
            },
        },
        methods: {
            async toggleSelectAllTrainees(value) {
                if (this.selectionLoading || this.approvalLoading || this.bulkCertificateLoading) return;
                if (!value) {
                    this.selected = [];
                    this.allSelectionIds = [];
                    return;
                }
                const query = this.traineeSelectionQuery;
                this.selectionLoading = true;
                try {
                    const response = await request(query);
                    // A filter change while loading must not restore an old selection.
                    if (query !== this.traineeSelectionQuery) return;
                    if (response.status !== 200 || !Array.isArray(response.data?.rows)) {
                        throw new Error("Unable to select all trainees. Please try again.");
                    }
                    const rows = response.data.rows.filter((item) => this[canSelectMethod](item));
                    this.selected = rows;
                    this.allSelectionIds = rows.map((item) => String(item.id));
                } catch (error) {
                    this.$toast.error(error.message || "Unable to select all trainees. Please try again.");
                } finally {
                    this.selectionLoading = false;
                }
            },
        },
    };
}
